import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import tab1 from '../assets/image/Use Cases_tb1.png'
import tab2 from '../assets/image/Use Cases_tb2.png'
import tab3 from '../assets/image/Use Cases_tb3.png'
import tab4 from '../assets/image/Use Cases_tb4.png'
import tab5 from '../assets/image/Use Cases_tb5.png'
import tab6 from '../assets/image/Use Cases_tb6.png'
import tab7 from '../assets/image/Use Cases_tb7.png'
import utab1 from '../assets/image/Use Cases_tb1_u.png'
import utab2 from '../assets/image/Use Cases_tb2_u.png'
import utab3 from '../assets/image/Use Cases_tb3_u.png'
import utab4 from '../assets/image/Use Cases_tb4_u.png'
import utab5 from '../assets/image/Use Cases_tb5_u.png'
import utab6 from '../assets/image/Use Cases_tb6_u.png'
import utab7 from '../assets/image/Use Cases_tb7_u.png'
import active_tab1 from '../assets/image/Use Cases_tb1_xt.png'
import active_tab2 from '../assets/image/Use Cases_tb2_xt.png'
import active_tab3 from '../assets/image/Use Cases_tb3_xt.png'
import active_tab4 from '../assets/image/Use Cases_tb4_xt.png'
import active_tab5 from '../assets/image/Use Cases_tb5_xt.png'
import active_tab6 from '../assets/image/Use Cases_tb6_xt.png'
import active_tab7 from '../assets/image/Use Cases_tb7_xt.png'

export default new Vuex.Store({
    state: {
     load_show:false,
     menuList:[    
      {id:1,title:'Products',path:'',child:[{id:10,title:'Card Payments',path:'card-payments'},{id:11,title:'Card Payouts',path:'card-payouts'},]},
      {id:16,title:'Use Cases',path:'',child:[
        {id:12,title:'Travel & Tourism',path:'travel-tourism',icons:{unActive:utab6,active:active_tab6}},{id:13,title:'E-Commerce',path:'e-commerce',icons:{unActive:utab1,active:active_tab1}},
        {id:14,title:'E-SaaS',path:'e-saas',icons:{unActive:utab4,active:active_tab4}},{id:15,title:'Retail',path:'retail',icons:{unActive:utab7,active:active_tab7}},
        {id:17,title:'Educational Platforms',path:'educational-platforms',icons:{unActive:utab5,active:active_tab5}},{id:18,title:'Online Gaming',path:'online-gaming',icons:{unActive:utab3,active:active_tab3}},
        {id:19,title:'Marketplaces',path:'marketplaces',icons:{unActive:utab2,active:active_tab2}},
      ]},
      // {id:3,title:'Games',path:'games'},
      {id:2,title:'About Us',path:'about-us'},
      // {id:4,title:'pages',path:'',child:[{id:5,title:'Privacy Policy',path:'privacy-policy',},{id:6,title:'Terms Of Use',path:'terms',}]},
      // {id:5,title:'Privacy Policy',path:'privacy-policy',},
      // {id:6,title:'Terms Of Use',path:'terms',},
      {id:9,title:'Contact Us',path:'contact-us',},
      // {id:7,title:'TERMS AND CONDITIONS',path:'terms'}
      // {id:8,title:'Join',path:'join',},
     
      ],
      joinList:[
   
      ],
      tabList:[
        {id:1,title:'E–Commerce',icon:tab1},{id:2,title:'Marketplaces',icon:tab2},{id:3,title:'Online Gaming',icon:tab3},{id:4,title:'SaaS',icon:tab4},{id:5,title:'Educational Platforms',icon:tab5},{id:6,title:'Travel & Tourism',icon:tab6},{id:7,title:'Retail',icon:tab7},
      ],
    },
  
    mutations: {
      setLoad (state, value) {
        state.load_show = value
      }, 
    },
   
})
